/* eslint-disable */
import {ICustomerOnboarding, INiraCredentials, IVerificationRequest} from "../../../modules/ninVerification/types";
import {IRequestDetails} from "../../../modules/ninVerification/types";

export const verificationRequestConstants = {
    RequestsFetchAll:"RequestsFetchAll",
    RequestsFetchLoading:"RequestsFetchLoading",
    RequestDetails: "RequestDetails",
    RequestsAddNew: "RequestsAddNew",
    RequestsPostNew: "RequestsPostNew",
    TurnOnSlideout:"TurnOnSlideout",
    RequestPostNiraCredentials: "RequestPostNiraCredentials",
    SET_SORT_PARAMS: "SET_SORT_PARAMS",
    FILTER_DATA: "FILTER_DATA",
    UPDATE_COUNT: "UPDATE_COUNT",
    FILTER_KYC_PERSON_DATA: 'FILTER_KYC_PERSON_DATA'
}

export interface IVerificationRequestState {
    loading: boolean
    data: IVerificationRequest[]
    selectedCase?:IRequestDetails
    niraCredentials?: INiraCredentials
    turnOnSlideOut: boolean
    addNew:boolean
    count: number
    filter: {
        data: IVerificationRequest[]
        filteredBy: string
        key: string
    }
    sorting: {
        order: string
        column: string
    }
}

const initialState: IVerificationRequestState = {
    loading: false,
    data: [],
    selectedCase: undefined,
    niraCredentials: undefined,
    turnOnSlideOut: false,
    addNew: false,
    count: 0,
    filter: {
        filteredBy: '',
        data: [],
        key: '',
    },
    sorting: {
        order: 'asc',
        column: ''
    }

}


export default function reducer(state = initialState, action: any) {
    switch (action.type) {

        case verificationRequestConstants.FILTER_DATA:
            return {...state, ...action.payload}

        case verificationRequestConstants.FILTER_KYC_PERSON_DATA:
            return {...state, ...action.payload}

        case verificationRequestConstants.SET_SORT_PARAMS:
            return {...state, ...action.payload}

        case verificationRequestConstants.RequestsFetchAll: {
            return {...state, loading: false, data: action.payload}
        }
        case verificationRequestConstants.UPDATE_COUNT: {
            return {...state, loading: false, count: action.payload}
        }
        case verificationRequestConstants.RequestsFetchLoading: {
            return {...state, loading: action.payload}
        }

        case verificationRequestConstants.RequestDetails: {
            return {...state, selectedCase: action.payload}
        }

        case verificationRequestConstants.RequestsAddNew: {
            return {...state, addNew: action.payload}
        }
        case verificationRequestConstants.TurnOnSlideout: {
            return {...state, turnOnSlideOut: action.payload}
        }

        case verificationRequestConstants.RequestsPostNew: {
            const newNinVerificationRequest: IVerificationRequest = action.payload
            return {...state, data: [newNinVerificationRequest, ...state.data]}
        }
        case verificationRequestConstants.RequestPostNiraCredentials: {
            return {...state, niraCredentials: action.payload}
        }

        default: {
            return state
        }
    }
}
